import { Navigate, useLocation } from "react-router-dom"
import { EnergyPassportPage } from "@/features/energy-passport/ui"
import EnergyPassportWrapper from "@/features/energy-passport/ui/energy-passport-wrapper.tsx"
import { companyEnergyAuditHistoryRoutes } from "@/pages/dashboard/company-energy-audit/history/routes.ts"
import type { CustomRoute } from "@/shared/types"

export const energyPassportRoutes: CustomRoute = {
  path: "energy-passport",
  handle: {
    label: "Энергопаспорт",
    i18Key: "energy-passport",
    icon: "ChartBubble",
    ignoreChildren: true,
    hideTabs: true
  },
  element: <EnergyPassportWrapper />,
  children: [
    {
      index: true,
      element: <RedirectToCurrentYear />
    },
    {
      path: ":year",
      handle: { hideTabs: true },
      Component: EnergyPassportPage
    },
    companyEnergyAuditHistoryRoutes
  ]
}

export function RedirectToCurrentYear() {
  const location = useLocation()
  const search = location.search
  const currentYear = (new Date().getFullYear() - 1).toString()

  return <Navigate to={`${currentYear}${search}`} replace />
}
